import { Injectable } from "@angular/core";
import { ResultListVO } from "@app/shared/vo/resultList.vo";
import { MapperInterface } from "./mapper-inteface";
import { ResultListDTO } from "../dto/result-listDTO";
import { MapperPaginazione } from "./mapper-paginazione";
import { AttoDTO } from "../dto/atto-DTO";
import { AttoVO } from "../vo/attoVO";
import { MapperAtto } from "./mapper-atto";



@Injectable({
    providedIn: "root"
})
export class MapperResultListAtto implements MapperInterface<ResultListDTO<AttoDTO>, ResultListVO<AttoVO>> {

    constructor(
        private mapperAtto: MapperAtto,
        private paginazioneMapper: MapperPaginazione) {
    }

    convertVoToDto(vo: ResultListVO<AttoVO>): ResultListDTO<AttoDTO> {
        const dto = new ResultListDTO<AttoDTO>();
        if (vo != null) {
            dto.descrizione = vo.descrizione;
            dto.paginazione = this.paginazioneMapper.convertVoToDto(vo.paginazione);
            dto.stato = vo.stato;
            dto.resultList = this.mapperAtto.convertListVoToDto(vo.resultList);
        }
        return dto;
    }

    convertDtoToVo(dto: ResultListDTO<AttoDTO>): ResultListVO<AttoVO> {
        const vo = new ResultListVO<AttoVO>();
        if (dto != null) {
            vo.descrizione = dto.descrizione;
            vo.paginazione = this.paginazioneMapper.convertDtoToVo(dto.paginazione);
            vo.stato = dto.stato;
            vo.resultList = this.mapperAtto.convertListDtoToVo(dto.resultList);
        }
        return vo;
    }

    convertListVoToDto(voList: ResultListVO<AttoVO>[]): ResultListDTO<AttoDTO>[] {
        return voList.map(vo => this.convertVoToDto(vo));
    }

    convertListDtoToVo(dtoList: ResultListDTO<AttoDTO>[]): ResultListVO<AttoVO>[] {
        return dtoList.map(dto => this.convertDtoToVo(dto));
    }
}
